import { Component } from '@angular/core';
import { IonicPage, NavController, NavParams, LoadingController, Platform, Toast, AlertController } from 'ionic-angular';
import { VehicleProvider } from '../../providers/vehicle/vehicle';
import { ToastProvider } from '../../providers/toast/toast';
import { MyVehiclePage } from '../my-vehicle/my-vehicle';
import { TranslateService } from '@ngx-translate/core';

@IonicPage()
@Component({
  selector: 'page-add-vehicle',
  templateUrl: 'add-vehicle.html',
})
export class AddVehiclePage {

  owner: string = null;
  vehicleModel: string = null;
  vehicleNum: string = null;
  insExDate: string = null;
  insNum: string = null;
  vehicleType: string = null;
  rfID: string = null;
  strNo: string = null;
  secretCode: string = null;
  loading = false;
  editPage = false;
  isRegistered = null;
  provider = null
  providers = [] ;
  id =null;
  constructor(
    public navCtrl: NavController, 
    public navParams: NavParams,
    private translate: TranslateService,
    private vehicleProvider: VehicleProvider,
    private toast: ToastProvider,
    private loadingCtrl: LoadingController,
    private platform: Platform,
    public alertCtrl: AlertController
    ) {
      let data = navParams.get("data");
      this.providers = navParams.get("providers");
      if(data){
        this.editPage = true;
        this.id = data.id;
        this.owner = data.owner?data.owner:'';
        this.vehicleModel= data.model?data.model:'';
        this.vehicleNum = data.vehicle_no?data.vehicle_no:'';
        this.insExDate = data.ins_exp_date?data.ins_exp_date:'';
        this.insNum = data.ins_no?data.ins_no:'';
        this.vehicleType = data.type?data.type:'';
        this.rfID = data.rf_id?data.rf_id:'';
        this.provider = data.provider?data.provider:null;
        this.strNo = data.stk_no?data.stk_no:'';
        this.secretCode = data.secret_code?data.secret_code:'';
        this.isRegistered = data.is_registered?data.is_registered:null;
        console.log(">>>>>>>>>>>>>>"+this.isRegistered);
        

      }
    }

    selectProvider() {
      if(this.providers && this.providers.length>0){
        let alert = this.alertCtrl.create();
        alert.setTitle('Select Providers');

        this.providers.forEach(val => {
          alert.addInput({
            type: 'radio',
            label: val.service,
            value: val.service,
            checked: true
          });
          alert.addButton('Cancel');
          alert.addButton({
            text: 'OK',
            handler: data => {
              this.provider = data
            }
          });
          alert.present();
        })
      }else{
        const alert = this.alertCtrl.create({
          title: 'No Provider!',
          subTitle: 'Currently there are no providers configured. Kindly contact Admin',
          buttons: ['OK']
        });
        alert.present();
      }
    }


  onSubmit(){
    let loader = this.loadingCtrl.create({});
    loader.present().then(() => {
      if(this.validate() ){
        let data  = {
          owner: this.owner,
          model: this.vehicleModel,
          vehicle_no: this.vehicleNum,
          ins_exp_date: this.insExDate,
          ins_no: this.insNum,
          type: this.vehicleType,
          rf_id : this.rfID,
          provider: this.provider,
          stk_no: this.strNo,
          secret_code: this.secretCode,
        }
        // console.log(data);
        if( this.editPage){
          this.vehicleProvider.editVehicleDetail(data, this.id).then(val => {
            this.toast.presentToast(val.message);
            // console.log(val);
            loader.dismiss();
            this.navCtrl.pop();
            this.navParams.get('parent').refreshVehicle();
          }).catch(val => {
            if(val.status == "error")
            loader.dismiss();
            // this.toast.presentToast(val.message);
          }); 
        }else{
          this.vehicleProvider.addVehicleDetail(data).then(val => {
            this.toast.presentToast(val.message);
            // console.log(val);
            loader.dismiss();
            this.navCtrl.pop();
            this.navParams.get('parent').refreshVehicle();
          }).catch(val => {
            if(val.status == "error")
            loader.dismiss();
            // this.toast.presentToast(val.message);
          }); 
        }
      }else{
        loader.dismiss();
      }
    });
  }

  validate(){
    if(!this.owner){
      this.toast.presentToast('Fill owner detail');
      return false;
    }
    if(!this.vehicleModel){
      this.toast.presentToast('Fill vehicle model');
      return false;
    }
    if(!this.vehicleNum){
      this.toast.presentToast('Fill vehicle number');
      return false;
    }
    if(this.owner.trim() && this.vehicleModel.trim() && this.vehicleNum.trim() && this.vehicleType){
      this.owner = this.owner.charAt(0).toUpperCase() + this.owner.substr(1).toLowerCase();
      this.vehicleModel = this.vehicleModel.toUpperCase();
      this.vehicleNum = this.vehicleNum.toUpperCase();
      return true;
    }else{
      this.toast.presentToast('Fill require detail');
      return false;
    }
  }

  ionViewDidLoad() {
    console.log('ionViewDidLoad AddVehiclePage');
  }

}



// WEBPACK FOOTER //
// ./src/pages/add-vehicle/add-vehicle.ts